export class Login{
    public Username:string="";
    public Password:string="";
}